<template>
  <van-popup v-model="showBind" class="backRect" @closed="onClosed">
    <TopBar :pagetitle="title" :is-left-self="true" @leftClick="onBack" />
    <van-field
      v-model="name"
      required
      clearable
      maxlength="20"
      label="姓名"
      placeholder="请输入微信关联的姓名"
    />

    <div class="buttonRect">
      <van-button type="primary" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="onBindPhone">绑定并激活</van-button>
    </div>
    <div class="regAbout">
      绑定微信账号并激活商城，请输入真实的姓名，绑定后系统将会在订单完成时自动结算销售佣金。
    </div>
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Button, Popup, Field, Toast } from 'vant'
import { MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    TopBar
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
  },
  data() {
    return {
      title: '激活并绑定',
      showBind: false,
      buttonLoading: false,
      name: ''
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.showBind = true
      } else {
        this.showBind = false
      }
    }
  },
  created() {

  },
  methods: {
    MyNotify,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {

    },
    onClosed() {
      this.$emit('input', false)
    },
    onBack() {
      this.showBind = false
      return true
    },
    onBindPhone() {
      if (!this.name || this.name.lenght < 2) {
        MyNotify('info', '请输入姓名')
        return
      }
      this.buttonLoading = true
      request({
        url: '/pro/bindWeChatProfitSharing',
        method: 'post',
        params: {
          name: this.name
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        Toast.success('激活并绑定成功,请返回首页刷新!')
        this.showBind = false
        this.$emit('reload')
      })
    }

  }
}
</script>
<style scoped>
.backRect{
    width: 100vw;
    height: 100vh;
    background-color: #F1f1f1;
}
.inputRect{
  margin: 1em 1em 0 1em;
  background-color: #fff;
  border-radius: 0.5em;
  overflow: hidden;
}
.regAbout{
  margin:1em 2em;
  color: #999;
  font-size: 0.8em;
}
</style>
